// extracted by mini-css-extract-plugin
module.exports = {"disabledButton":"AssignmentCreator_disabledButton__iB-mt"};